import { render, staticRenderFns } from "./talentCardCourse.vue?vue&type=template&id=c3ef1112&scoped=true&"
import script from "./talentCardCourse.vue?vue&type=script&lang=js&"
export * from "./talentCardCourse.vue?vue&type=script&lang=js&"
import style0 from "./talentCardCourse.vue?vue&type=style&index=0&id=c3ef1112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ef1112",
  null
  
)

export default component.exports